import { LinearProgress } from "@mui/material"
import { useAppSelector } from "app/redux/hooks"
import React from "react"

// Migração MUI v4 -> v9: `makeStyles` não existe mais (saiu no v6). O equivalente é `sx`.
// As três classes do v4 viravam duas cores só: `root` e `colorPrimary` pintavam o MESMO elemento
// (a trilha) com `cor`, e `barColorPrimary` pintava a barra de progresso de branco — é isso que o
// `sx` abaixo reproduz, sem os nomes de classe intermediários.
export const MuLinearProgress = () => {
    const cor = useAppSelector(store => store.corLinearProgress)

    return <LinearProgress
        color="primary"
        sx={{
            backgroundColor: cor,
            '& .MuiLinearProgress-bar': { backgroundColor: '#fff' },
        }}
    />
}